module.exports = __webpack_public_path__ + "img/9_natalie_d.b616b566.png";